import { render, staticRenderFns } from "./route_freeze.vue?vue&type=template&id=95a9374c&scoped=true"
import script from "./route_freeze.vue?vue&type=script&lang=js"
export * from "./route_freeze.vue?vue&type=script&lang=js"
import style0 from "./route_freeze.vue?vue&type=style&index=0&id=95a9374c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a9374c",
  null
  
)

export default component.exports